import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Optional,
  Renderer2,
  Self,
  TemplateRef,
} from '@angular/core';
import { NgControl } from '@angular/forms';

import { Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';

import { GasInputBoolean, NgOnInit } from '@cikrf/gas-utils/decorators';

import { GasFormBaseComponent } from '../../gas-form-base-component';
import { GasForm } from '../../gas-form.namespace';

/**@see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=3539%3A36470
 * @description Переключатель для контроля состояний включено/выключено.
 * @param type (GasSwitchTypeConstant) - тип переключателя
 * @param value - текущее состояние
 * @param disabled - состояние неактивности
 * @param error - состояние ошибки
 * @exapmle <gas-switch type="primary" [value]="false" description="Опсиание" disabled [error]="false">Название переключателя</gas-switch>
 */

@Component({
  selector: 'gas-switch',
  templateUrl: './gas-switch.component.html',
  styleUrls: ['./gas-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSwitchComponent extends GasFormBaseComponent {

  /** Текущее состояние переключателя */
  @GasInputBoolean()
  @Input()
  public value: string | boolean = false;

  /** Состояние ошибки */
  @GasInputBoolean()
  @Input('error')
  public isError: string | boolean = false;

  /** @deprecated */
  @Input()
  public label: string | TemplateRef<ElementRef>;

  /** @deprecated */
  @Input()
  public enabledText: string;

  /** @deprecated */
  @Input()
  public disabledText: string;

  @NgOnInit()
  public onInit$!: Observable<void>;

  public disabled$: Observable<boolean | string> = this.onInit$.pipe(
    startWith(false),
    switchMap(() => this.ngControl?.control.statusChanges || of(false)),
    map((status: GasForm.States) => status === GasForm.States.Disabled),
  );

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    @Self() @Optional() private ngControl: NgControl,
  ) {
    super(changeDetectorRef, elementRef, renderer);

    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  public onSwitchChange(isSwitch: boolean): void {
    this.form.setValue(isSwitch);
  }

}
